import { render, staticRenderFns } from "./ProjectTaskFiles.vue?vue&type=template&id=1f2db44f&scoped=true&"
import script from "./ProjectTaskFiles.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProjectTaskFiles.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2db44f",
  null
  
)

export default component.exports